class MenuDrawer2 extends HTMLElement {
    constructor() {
        super();
        this.isOpen = false;
        this.closeSubmenuTimeout = null;
    }

    connectedCallback() {
        this.setupDesktopSubmenuHover();
        this.setupScrollHeader();

        this.button = this.querySelector('.header-hamburguerContainer');
        this.drawer = this.querySelector('.header-menu-drawer');
        this.overlay = this.querySelector('.header-menu-overlay');

        if (!this.button || !this.drawer || !this.overlay) return;

        this.setDrawerFocusable(false);
        this.drawer.setAttribute('inert', '');

        // Evita animación de "esconderse" al cargar: activamos transición después del primer render.
        requestAnimationFrame(() => {
            this.drawer.classList.add('is-ready');
        });

        this.button.addEventListener('click', () => this.toggle());
        this.overlay.addEventListener('click', () => this.close());
    }

    setupScrollHeader() {
        const header = this.querySelector('.header');
        if (!header) return;

        const SCROLL_THRESHOLD = 60;

        const update = () => {
            if (this.isOpen) return;
            if (window.scrollY > SCROLL_THRESHOLD) {
                header.classList.add('is-scrolled');
            } else {
                header.classList.remove('is-scrolled');
            }
        };

        update();
        window.addEventListener('scroll', update, { passive: true });
    }

    setupDesktopSubmenuHover() {
        const desktopMedia = window.matchMedia('(min-width: 768px)');
        const navItem = this.querySelector('.header-nav-item--has-submenu');
        const submenu = navItem?.querySelector('.header-submenu');

        if (!navItem || !submenu) return;

        const keepOpen = () => {
            if (!desktopMedia.matches) return;
            clearTimeout(this.closeSubmenuTimeout);
            navItem.classList.add('is-hover-open');
        };

        const scheduleClose = () => {
            if (!desktopMedia.matches) return;
            clearTimeout(this.closeSubmenuTimeout);
            this.closeSubmenuTimeout = setTimeout(() => {
                navItem.classList.remove('is-hover-open');
            }, 220);
        };

        navItem.addEventListener('mouseenter', keepOpen);
        navItem.addEventListener('mouseleave', scheduleClose);
        submenu.addEventListener('mouseenter', keepOpen);
        submenu.addEventListener('mouseleave', scheduleClose);

        if (desktopMedia.addEventListener) {
            desktopMedia.addEventListener('change', (event) => {
                if (!event.matches) navItem.classList.remove('is-hover-open');
            });
        }
    }

    toggle() {
        this.isOpen ? this.close() : this.open();
    }

    setDrawerFocusable(focusable) {
        const links = this.drawer.querySelectorAll('a, button');
        links.forEach((el) => {
            if (focusable) {
                el.removeAttribute('tabindex');
            } else {
                el.setAttribute('tabindex', '-1');
            }
        });
    }

    open() {
        this.isOpen = true;
        this.querySelector('.header')?.classList.remove('is-scrolled');
        this.drawer.classList.add('is-open');
        this.overlay.classList.add('is-active');
        this.drawer.removeAttribute('inert');
        this.drawer.setAttribute('aria-hidden', 'false');
        this.setDrawerFocusable(true);
    }

    close() {
        this.isOpen = false;
        this.drawer.classList.remove('is-open');
        this.overlay.classList.remove('is-active');
        this.drawer.setAttribute('inert', '');
        this.drawer.setAttribute('aria-hidden', 'true');
        this.setDrawerFocusable(false);
    }

    // disconnectedCallback() {
    //     console.log('eliminado del DOM');
    // }
}

customElements.define('menu-drawer-2', MenuDrawer2);